export default class Nav {
    constructor() {
        if(document.getElementById('nav-trigger') === null){
            throw new ReferenceError('[Nav.js] `#nav-trigger` element missing');
        }

        if(document.getElementById('menu-primary-navigation') === null){
            throw new ReferenceError('[Nav.js] `#menu-primary-navigation` element missing');
        }

        this.trigger = document.getElementById('nav-trigger') || null;
        this.menu    = document.getElementById('menu-primary-navigation') || null;

        this.initEvents();
    }

    initEvents() {
        if(this.trigger !== null){
            this.trigger.addEventListener('click', this.toggleMainNav.bind(this));
        }

        if(this.menu.querySelector('.menu-item-has-children > a') !== null){
            this.menu.querySelectorAll('.menu-item-has-children > a').forEach(el => {
                el.addEventListener('click', this.openSubMenu.bind(this));
            });
        }

        if(this.menu.querySelector('.menu-item-has-children .back-button') !== null){
            this.menu.querySelectorAll('.menu-item-has-children .back-button').forEach(el => {
                el.addEventListener('click', this.closeSubMenu.bind(this));
            });
        }
    }

    toggleMainNav(ev){
        ev.preventDefault();

        this.trigger.innerText = (this.trigger.classList.contains('active')) ? 'Menu' : 'Close';
        if(this.trigger.classList.contains('active') && this.menu.querySelector('.sub-menu-wrapper') !== null){
            this.menu.querySelectorAll('.sub-menu-wrapper').forEach(el => el.classList.remove('open'));
        }
        this.trigger.classList.toggle('active');
        this.menu.classList.toggle('open');
        document.body.classList.toggle('nav-open');
    }

    openSubMenu(ev){
        if(window.outerWidth < 992){
            ev.preventDefault();
            ev.currentTarget.nextElementSibling.classList.add('open');
        }
    }

    closeSubMenu(ev){
        ev.preventDefault();
        ev.currentTarget.closest('.sub-menu-wrapper').classList.remove('open');
    }
}